import { SharedProps, VariantType, useSnackbar } from "notistack";
import { useCallback } from "react";

export interface SnackbarProps extends SharedProps {
  message: string;
  variant: VariantType;
}

const useDialogAlert = () => {
  const { enqueueSnackbar } = useSnackbar();

  const snackbar = useCallback(
    (props: SnackbarProps) => {
      const { message, variant, ...rest } = props;
      enqueueSnackbar(message, {
        variant,
        ...rest,
      });
    },
    [enqueueSnackbar]
  );

  return { snackbar };
};

export default useDialogAlert;
